"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.RWSToolsOfferCreatorDataComponent = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const types_1 = require("../../types");
//@ts-ignore                
let rwsTemplate = T.html `<div class="rws-tools-offer-creator-data">
    ${(0, fast_element_1.when)(x => { var _a; return (_a = x.offerData) === null || _a === void 0 ? void 0 : _a.sendForm; }, (0, fast_element_1.html) `
        <div class="send-form-badge">
            <i class="simple-icon-check"></i>
            ${'offerCreator.formSent'.t()}
        </div>
    `)}

    ${(0, fast_element_1.when)(x => x.getFilledFields().length > 0, (0, fast_element_1.html) `
        <div class="fields-container">
            ${(0, fast_element_1.repeat)(x => x.getFilledFields(), (0, fast_element_1.html) `
                <div class="field-row">
                    <span class="field-label">${field => field.label}</span>
                    <span class="field-value">${field => field.value}</span>
                </div>
            `)}
        </div>
    `)}

    ${(0, fast_element_1.when)(x => x.getFilledFields().length === 0, (0, fast_element_1.html) `
        <div class="empty-state">
            <span class="empty-icon">📝</span>
            <p>${'offerCreator.noData'.t()}</p>
        </div>
    `)}
</div>
`;
require("./styles/layout.scss");
const styles = T.css `@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.rws-tools-offer-creator-data {
  border-radius: 12px;
}
.rws-tools-offer-creator-data .send-form-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: var(--success-color-light, #d4edda);
  color: var(--success-color-dark, #155724);
  border: 1px solid var(--success-color, #28a745);
  border-radius: 16px;
  padding: 4px 12px;
  font-size: 0.85rem;
  font-weight: 500;
  margin-bottom: 12px;
}
.rws-tools-offer-creator-data .fields-container {
  background: var(--bg-secondary, #f8f9fa);
  border-radius: 8px;
  padding: 16px;
  display: grid;
  gap: 8px;
}
.rws-tools-offer-creator-data .fields-container .field-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: var(--bg-tertiary, #ffffff);
  border: 1px solid var(--border-color-light, #dee2e6);
  border-radius: 6px;
}
.rws-tools-offer-creator-data .fields-container .field-row .field-label {
  font-weight: 600;
  color: var(--text-secondary, #6c757d);
  font-size: 0.85rem;
}
.rws-tools-offer-creator-data .fields-container .field-row .field-value {
  color: var(--text-primary, #1a1a1a);
  font-size: 0.9rem;
  font-weight: 500;
  text-align: right;
  word-break: break-word;
  max-width: 60%;
}
.rws-tools-offer-creator-data .empty-state {
  text-align: center;
  padding: 32px 16px;
  color: var(--text-secondary, #6c757d);
}
.rws-tools-offer-creator-data .empty-state .empty-icon {
  font-size: 3rem;
  margin-bottom: 16px;
  display: block;
  opacity: 0.7;
}
.rws-tools-offer-creator-data .empty-state p {
  margin: 0;
  font-size: 1rem;
  font-weight: 500;
}
.rws-tools-offer-creator-data .empty-state .empty-suggestion {
  color: var(--text-tertiary, #9ca3af);
  font-size: 0.9rem;
  font-style: italic;
  margin-top: 8px;
}
[data-theme=dark] .rws-tools-offer-creator-data .tool-container {
  background: var(--bg-secondary-dark, #2d3748);
}
[data-theme=dark] .rws-tools-offer-creator-data .tool-list-item {
  background: var(--bg-tertiary-dark, #374151);
  border-color: var(--border-color-light-dark, #4a5568);
  color: var(--text-secondary-dark, #a0aec0);
}
[data-theme=dark] .rws-tools-offer-creator-data .tool-list-item .item-title {
  color: var(--text-primary-dark, #f7fafc);
}
[data-theme=dark] .rws-tools-offer-creator-data .tool-list-item .item-subtitle {
  color: var(--text-tertiary-dark, #718096);
}
[data-theme=dark] .rws-tools-offer-creator-data .tool-list-item .item-description {
  color: var(--text-secondary-dark, #a0aec0);
  border-top-color: var(--border-color-light-dark, #4a5568);
}
[data-theme=dark] .rws-tools-offer-creator-data .tool-list-item:hover {
  background: var(--bg-hover-dark, #4a5568);
  border-color: var(--primary-color-dark, #63b3ed);
}
[data-theme=dark] .rws-tools-offer-creator-data .tool-list-item:hover::after {
  background: var(--primary-color-dark, #63b3ed);
}
[data-theme=dark] .rws-tools-offer-creator-data .tool-query-display {
  background: var(--bg-secondary-dark, #2d3748);
  border-left-color: var(--primary-color-dark, #63b3ed);
}
[data-theme=dark] .rws-tools-offer-creator-data .tool-query-display .query-label {
  color: var(--text-secondary-dark, #a0aec0);
}
[data-theme=dark] .rws-tools-offer-creator-data .tool-query-display .query-text {
  color: var(--text-primary-dark, #f7fafc);
  background: var(--bg-tertiary-dark, #374151);
  border-color: var(--border-color-light-dark, #4a5568);
}
[data-theme=dark] .rws-tools-offer-creator-data .tool-results-summary {
  background: var(--success-color-dark-bg, #1e4d2b);
  border-color: var(--success-color-dark, #68d391);
}
[data-theme=dark] .rws-tools-offer-creator-data .tool-results-summary .results-count {
  color: var(--success-color-dark, #68d391);
}
[data-theme=dark] .rws-tools-offer-creator-data .tool-empty-state {
  color: var(--text-secondary-dark, #a0aec0);
}
[data-theme=dark] .rws-tools-offer-creator-data .tool-empty-state p {
  color: var(--text-primary-dark, #f7fafc);
}
[data-theme=dark] .rws-tools-offer-creator-data .tool-empty-state .empty-suggestion {
  color: var(--text-tertiary-dark, #718096);
}
[data-theme=dark] .rws-tools-offer-creator-data .tool-loading-state {
  color: var(--text-secondary-dark, #a0aec0);
}
[data-theme=dark] .rws-tools-offer-creator-data .tool-loading-state .spinner {
  border-color: var(--border-color-dark, #4a5568);
  border-top-color: var(--primary-color-dark, #63b3ed);
}
@media (max-width: 768px) {
  .rws-tools-offer-creator-data {
    padding: 16px;
    margin: 12px 0;
  }
  .rws-tools-offer-creator-data h3 {
    font-size: 1.1rem;
  }
  .rws-tools-offer-creator-data h4 {
    font-size: 0.95rem;
  }
  .rws-tools-offer-creator-data .tool-container {
    padding: 12px;
  }
  .rws-tools-offer-creator-data .tool-list-item {
    padding: 10px 12px;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  .rws-tools-offer-creator-data .tool-list-item .item-title {
    font-size: 0.9rem;
  }
  .rws-tools-offer-creator-data .tool-list-item .item-description {
    font-size: 0.85rem;
  }
}
@media (max-width: 480px) {
  .rws-tools-offer-creator-data .tool-empty-state {
    padding: 24px 12px;
  }
  .rws-tools-offer-creator-data .tool-empty-state .empty-icon {
    font-size: 2rem;
  }
  .rws-tools-offer-creator-data .tool-empty-state p {
    font-size: 0.9rem;
  }
}`;
const shadowOptions = { "mode": "open" };
let RWSToolsOfferCreatorDataComponent = class RWSToolsOfferCreatorDataComponent extends client_1.RWSViewComponent {
    offerDataChanged() {
        var _a;
        if ((_a = this.offerData) === null || _a === void 0 ? void 0 : _a.sendForm) {
            this.$emit('form-sent', { toolName: 'offerCreator', data: this.offerData });
        }
    }
    getFilledFields() {
        if (!this.offerData)
            return [];
        const fields = [];
        const data = this.offerData;
        if (data.company_name)
            fields.push({ label: 'offerCreator.companyName'.t(), value: data.company_name });
        if (data.first_name)
            fields.push({ label: 'offerCreator.firstName'.t(), value: data.first_name });
        if (data.last_name)
            fields.push({ label: 'offerCreator.lastName'.t(), value: data.last_name });
        if (data.email)
            fields.push({ label: 'offerCreator.email'.t(), value: data.email });
        if (data.phone)
            fields.push({ label: 'offerCreator.phone'.t(), value: data.phone });
        if (data.vat_payer !== undefined)
            fields.push({ label: 'offerCreator.vatPayer'.t(), value: data.vat_payer ? 'common.yes'.t() : 'common.no'.t() });
        if (data.employees_number)
            fields.push({ label: 'offerCreator.employeesNumber'.t(), value: String(data.employees_number) });
        if (data.business_activity_type)
            fields.push({ label: 'offerCreator.businessActivity'.t(), value: data.business_activity_type });
        if (data.taxation_type)
            fields.push({ label: 'offerCreator.taxationType'.t(), value: data.taxation_type });
        if (data.documents_number)
            fields.push({ label: 'offerCreator.documentsNumber'.t(), value: String(data.documents_number) });
        if (data.package_id)
            fields.push({ label: 'offerCreator.packageId'.t(), value: String(data.package_id) });
        if (data.additional_info)
            fields.push({ label: 'offerCreator.additionalInfo'.t(), value: data.additional_info });
        return fields;
    }
};
exports.RWSToolsOfferCreatorDataComponent = RWSToolsOfferCreatorDataComponent;
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_a = typeof types_1.OfferCreatorData !== "undefined" && types_1.OfferCreatorData) === "function" ? _a : Object)
], RWSToolsOfferCreatorDataComponent.prototype, "offerData", void 0);
exports.RWSToolsOfferCreatorDataComponent = RWSToolsOfferCreatorDataComponent = __decorate([
    (0, client_1.RWSView)('rws-tools-offer-creator-data', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], RWSToolsOfferCreatorDataComponent);
RWSToolsOfferCreatorDataComponent.defineComponent();
